import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import GiftDetailSection from './components/GiftDetailSection';
import BrandStory from './components/BrandStory';
import PresentSection from './components/PresentSection';
import ModelHouseSection from './components/ModelHouseSection';
import VideoSection from './components/VideoSection';
import ReservationGallery from './components/ReservationGallery';
import CampaignTerms from './components/CampaignTerms';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <GiftDetailSection />
        <BrandStory />
        <PresentSection />
        <ModelHouseSection />
        <VideoSection />
        <ReservationGallery />
        <CampaignTerms />
      </main>
      <Footer />
    </div>
  );
}